import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Container from '@/container'
import BusinessSectionTop from './business-section-top'

const BusinessSection = ({
  children,
  title,
  subtitle,
  topText,
  topGreen,
  gray,
  fullWidth,
  className
}) => {
  return (
    <div
      className={classNames({
        'pv5 pv6-m pv7-l': true,
        'bg-white': !gray,
        'bg-near-white': gray
      }, className)}
    >
      <Container fullWidth={fullWidth}>
        <BusinessSectionTop
          title={title}
          subtitle={subtitle}
          topText={topText}
          topGreen={topGreen}
        />
        {children}
      </Container>
    </div>
  )
}
BusinessSection.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.node
}

export default BusinessSection



// WEBPACK FOOTER //
// ./src/components/business-section/business-section.js